export default __webpack_public_path__ + "static/media/healthlogo.6487e7d2.jpg";